export enum MaterialIconCssClass {
  Outlined = 'material-symbols-outlined',
  Rounded = 'material-symbols-rounded',
  Sharp = 'material-symbols-sharp',
}
